export const indexData = {
  titleTop: require("@/assets/images/index/index-title.png"),
  briefTop: require("@/assets/images/index/brief-img.png"),
  list: [
    {
      topImg: require("@/assets/images/index/know.png"),
      centerImg: require("@/assets/images/index/know-number.png"),
      title: "知识产权",
      content: "截止2022年3月各类知识产权1046件",
      id: 1,
    },
    {
      topImg: require("@/assets/images/index/staff.png"),
      centerImg: require("@/assets/images/index/staff-number.png"),
      title: "在职员工",
      content:
        "在职员工2000余人，90%以上为本科学历、25%以上研究生学历，研发1000人、技术200人",
      id: 2,
    },
    {
      topImg: require("@/assets/images/index/offline.png"),
      centerImg: require("@/assets/images/index/offline-number.png"),
      title: "线下机构",
      content: "线下培训分校200家+",
      id: 3,
    },
    {
      topImg: require("@/assets/images/index/student.png"),
      centerImg: require("@/assets/images/index/student-number.png"),
      title: "学习人群",
      content: "年培训学员10万+",
      id: 4,
    },
    {
      topImg: require("@/assets/images/index/area.png"),
      centerImg: require("@/assets/images/index/area-number.png"),
      title: "覆盖省市",
      content: "图书业务覆盖全国26省年发行图书逾600万册",
      id: 5,
    },
    {
      topImg: require("@/assets/images/index/found.png"),
      centerImg: require("@/assets/images/index/found-number.png"),
      title: "成立至今",
      content:
        "15年致力于图书出版、线上线下培训，业务涵盖专升本、教师招聘、教师资格等",
      id: 6,
    },
  ],
  news: {
    lImg: require("@/assets/images/index/labour.jpg"),
    lTitle: "劳动新模范·库课新青年",
    lContent:
      "2022年4月29日上午，库课科技股份有限公司“新劳模、新青年、新未来——劳动新模范·库课新青年”双节颁奖盛典，在招银大厦22楼会议室盛大开幕！此次活动，标志库课科技精心打造的…",
    lType: "热点要闻",
    lTime: "2022.04.29",
    rTitle: "最新资讯",
    rText: "NEWS",
    rType: "信息动态共享 · 新闻记事历历在目",
    rSecond: "党建引领促发展 凝心聚力谱新篇",
    rOne: "【尊师爱教 库课荣耀】全国第38届教师节暨库课 · 天一教师年度盛典圆满举行",
    rTwo: "“库课铁军 荣耀出征”篮球、羽毛球团队PK赛启动仪式",
    rThree: "民建河南省委会主委梁留科等领导一行莅临库课科技调研工作",
    rFour: "【建党伟业 信仰力量】库课科技庆祝中国共产党建党101周年大会隆重召开",
    rMore: require("@/assets/images/index/view-more.png"),
  },
  product: {
    pList: [
      {
        id: 1,
        bgImg: require("@/assets/images/index/zx-bg.jpg"),
        title: "在线教育",
        content:
          "库课网校以“游戏化、碎片化、娱乐化、社交化”为特色，集点播、直播、题库于一体，致力于打造 “师资库、课程库、学员库、题库、资源库”五库一体兼具职业与学历教育专业特色的互联网教育平台。技术版本从1.0到2.0、3.0版本深度迭代，快速形成PC端、移动端教学平台。",
        img: require("@/assets/images/index/online.jpg"),
        icon: require("@/assets/images/index/zxjy.png"),
      },
      {
        id: 2,
        title: "线下教育",
        bgImg: require("@/assets/images/index/xl-bg.jpg"),
        content:
          "集团下设两大教育品牌，“天一专升本”“天一公职”“天一职教高考”深耕河南市场，“库课”布局全国市场。涵盖：专升本考试培训，教师招聘、教师资格、公务员、事业单位及三支一扶等公职考试培训和职教高考培训、成人继续教育培训。",
        img: require("@/assets/images/index/education.jpg"),
        icon: require("@/assets/images/index/xxjy.png"),
      },
      {
        id: 3,
        bgImg: require("@/assets/images/index/ts-bg.jpg"),
        title: "图书出版",
        content:
          "集团深耕图书研发与课程开发领域，正加速迈入智能融合的新时代，将AI技术深度融入出版链条的每一个环节，全力构建集“精品内容、高效服务、趣味互动”于一体的智慧出版新生态。",
        img: require("@/assets/images/index/book.jpg"),
        icon: require("@/assets/images/index/tscb.png"),
      },
      {
        id: 4,
        bgImg: require("@/assets/images/index/cj-bg.jpg"),
        title: "项目拓展",
        content:
          "聚焦学历提升和高质量就业培训领域，响应国家产教融合、职业技能提升等政策导向，重点投入技术中心（研发智能教学系统）、直播中心（构建全场景教学矩阵）、商学院（孵化职业教育师资）及校企合作（共建产业学院和实训基地）等延展项目，实现“人才共育-专业共建-成果共享”生态闭环。",
        img: require("@/assets/images/index/prod.jpg"),
        icon: require("@/assets/images/index/xmtz.png"),
      },
    ],
  },
  school: {
    eProvince: [
      {
        id: 1,
        img: require("@/assets/images/index/zz.jpg"),
        title: "郑州校区",
      },
      {
        id: 2,
        img: require("@/assets/images/index/ly.jpg"),
        title: "洛阳校区",
      },
      {
        id: 3,
        img: require("@/assets/images/index/xc.jpg"),
        title: "许昌校区",
      },
      {
        id: 4,
        img: require("@/assets/images/index/hb.jpg"),
        title: "鹤壁校区",
      },
      {
        id: 5,
        img: require("@/assets/images/index/ay.jpg"),
        title: "安阳校区",
      },
    ],
    oProvince: [
      {
        id: 1,
        img: require("@/assets/images/index/gz.png"),
        title: "广州校区",
      },
      {
        id: 2,
        img: require("@/assets/images/index/sjz.png"),
        title: "石家庄校区",
      },
      {
        id: 3,
        img: require("@/assets/images/index/cd.png"),
        title: "成都校区",
      },
      {
        id: 4,
        img: require("@/assets/images/index/jn.png"),
        title: "济南校区",
      },
      {
        img: require("@/assets/images/index/km.png"),
        id: 5,
        title: "昆明校区",
      },
    ],
  },
  partner: [
    require("@/assets/images/index/pic_logo.png"),
    require("@/assets/images/index/pic_logo.png"),
  ],
  recruit: {
    rList: [
      {
        link: "/joins",
        img: require("@/assets/images/index/people.png"),
        title: "人才理念",
        tag: "TALENT<br/>CONCEPT",
        content:
          "用人标准&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;人才画像&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;人才发展观",
      },
      {
        link: "/joins?#concept",
        img: require("@/assets/images/index/post.png"),
        title: "招聘岗位",
        tag: "RECRUITMENT<br/>POSITION",
        content:
          "校园招聘&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;社会招聘",
      },
    ],
    bImg: require("@/assets/images/logo.png"),
    ipImg: require("@/assets/images/index/ip-img.png"),
  },
};
export const companyData = {
  // 顶部banner
  bannerLink: require("@/assets/images/company/jtbj.png"),
  //   品牌矩阵
  brandLink: require("@/assets/images/company/ppqy.png"),
  // 集团战略
  groupStrategyLink: require("@/assets/images/company/jtzl.png"),

  brandLinkBg: require("@/assets/images/company/bg_ppgz.png"),
  //   公司管理
  administrationLink: require("@/assets/images/company/gsgl.png"),
  // 公司概况数据
  surveyObj: {
    content: `库课科技集团股份有限公司（以下简称库课科技集团）创立于2007年，是一家集数智内容
研发、应用及产教融合为一体的教育科技企业。
2021年4月6日，库课科技集团（股票代码：872898）从新三板摘牌，现为省级主板上市
重点后备企业。
秉持“科技引领”发展理念，库课科技集团下设：数智出版研究院、数智教学研究院、数
智商务研究院、AI技术研究院、库课数智商学院、产教融合研究院等部门。
2025年底，集团在职员工2000余人，共有软著、著作权、专利2500余项，课程服务覆盖
全国31个省区市，学习体验中心超300所，年培训学员逾百万人次，年销售图书超千万册。
集团先后荣获“全国教育榜样集团”“新华网AI+教育融合发展案例”“民办教育先进单位”
“综合影响力标杆教育集团”“口碑影响力职业教育品牌”等荣誉。
集团先后被授予“国家级科技型中小企业”“省级专精特新企业”“省级工程研发中心”“市
级数字经济重点企业”“市级科技小巨人企业”等资质。
未来，库课科技集团将紧跟国家战略规划，深耕职业教育领域，致力成为“学历提升及高质
量就业培训第一品牌”。`,
    link: require("@/assets/images/company/survey1.jpg"),
  },
  // 企业荣誉
  honorList: [
    require("@/assets/images/company/01.png"),
    require("@/assets/images/company/02.png"),
    require("@/assets/images/company/03.png"),
    require("@/assets/images/company/04.png"),
    require("@/assets/images/company/05.png"),
    require("@/assets/images/company/06.png"),
    require("@/assets/images/company/07.png"),
    require("@/assets/images/company/08.png"),
    require("@/assets/images/company/09.png"),
    require("@/assets/images/company/10.png"),
    require("@/assets/images/company/11.png"),
    require("@/assets/images/company/12.png"),
  ],
  // 公司管理
  administrationArr: [
    {
      link: require("@/assets/images/company/gltd.png"),
      title: "管理团队",
    },
    {
      link: require("@/assets/images/company/gqjg.png"),
      title: "股权架构",
    },
    {
      link: require("@/assets/images/company/zzjg.png"),
      title: "组织架构",
    },
  ],
  courseList: [
    {
      link: require("@/assets/images/company/y_2007.png"),
      activeLink: require("@/assets/images/company/y_2007_hover.png"),
    },
    {
      link: require("@/assets/images/company/y_2007_1.png"),
      activeLink: require("@/assets/images/company/y_2007_1_hover.png"),
    },
    {
      link: require("@/assets/images/company/y_2008.png"),
      activeLink: require("@/assets/images/company/y_2008_hover.png"),
    },
    {
      link: require("@/assets/images/company/y_2010.png"),
      activeLink: require("@/assets/images/company/y_2010_hover.png"),
    },
    {
      link: require("@/assets/images/company/y_2011.png"),
      activeLink: require("@/assets/images/company/y_2011_hover.png"),
    },
    {
      link: require("@/assets/images/company/y_2014.png"),
      activeLink: require("@/assets/images/company/y_2014_hover.png"),
    },
    {
      link: require("@/assets/images/company/y_2015.png"),
      activeLink: require("@/assets/images/company/y_2015_hover.png"),
    },
    {
      link: require("@/assets/images/company/y_2016.png"),
      activeLink: require("@/assets/images/company/y_2016_hover.png"),
    },
    {
      link: require("@/assets/images/company/y_2017.png"),
      activeLink: require("@/assets/images/company/y_2017_hover.png"),
    },
    {
      link: require("@/assets/images/company/y_2018.png"),
      activeLink: require("@/assets/images/company/y_2018_hover.png"),
    },
    {
      link: require("@/assets/images/company/y_2018_1.png"),
      activeLink: require("@/assets/images/company/y_2018_1_hover.png"),
    },
    {
      link: require("@/assets/images/company/y_2021.png"),
      activeLink: require("@/assets/images/company/y_2021_hover.png"),
    },
    {
      link: require("@/assets/images/company/y_2021_1.png"),
      activeLink: require("@/assets/images/company/y_2021_1_hover.png"),
    },
    {
      link: require("@/assets/images/company/y_2021_2.png"),
      activeLink: require("@/assets/images/company/y_2021_2_hover.png"),
    },
    {
      link: require("@/assets/images/company/y_2022.png"),
      activeLink: require("@/assets/images/company/y_2022_hover.png"),
    },
    {
      link: require("@/assets/images/company/y_2023.png"),
      activeLink: require("@/assets/images/company/y_2023_hover.png"),
    },
    {
      link: require("@/assets/images/company/y_2024.png"),
      activeLink: require("@/assets/images/company/y_2024_hover.png"),
    },
    {
      link: require("@/assets/images/company/y_2025.png"),
      activeLink: require("@/assets/images/company/y_2025_hover.png"),
    },
  ],
  societyArr: ["捐赠证书及凭证", "捐赠现场记录"],
  societyOne: "捐赠证书",
  societyTwo: "捐赠现场",
  acivteTab: 0,
  societyImgArr: [
    require("@/assets/images/company/jzzs.png"),
    require("@/assets/images/company/jzxc.png"),
  ],
  societyImgOne: require("@/assets/images/company/jzzs.png"),
  societyImgTwo: require("@/assets/images/company/jzxc.png"),
  news: [
    {
      src: "#",
      title:
        "【2022年4月】库课文化科技股份有限公司向河南省铭刻雕刻基金会捐赠现金10万元",
    },
    {
      src: "#",
      title:
        "【2021年7月-8月】向中华思源工程扶贫基金会捐款现金101.5万元，用于灾区重建……",
    },
    {
      src: "#",
      title:
        "【2021年7月】郑州“7·20”暴雨，捐款价值60余万元现金及物资，支持灾后重建",
    },
    {
      src: "#",
      title: "【2021年5月】向北京世华公益基金会捐赠现金50万元，助力公益慈善",
    },
    {
      src: "#",
      title:
        "【2020年11月】冠名“库课文化杯”第29届世界记忆锦标赛郑州赛区，关注脑力运动发展",
    },
  ],
  cultureArr: [
    {
      link: require("@/assets/images/company/sm.png"),
      title: "使命",
      content: `为天下学子<br />成就美好人生`,
    },
    {
      link: require("@/assets/images/company/yj.png"),
      title: "愿景",
      content: `成为学历提升及高质量<br/>就业培训第一品牌`,
    },
    {
      link: require("@/assets/images/company/zd.png"),
      title: "价值观",
      content: `学子为先  知行合一<br/>利他而为`,
    },
    {
      link: require("@/assets/images/company/jz.png"),
      title: "人才发展观",
      content: ` 发掘人 尊重人<br/>培养人 成就人`,
    },
  ],
  digitArr: [
    {
      link: require("@/assets/images/company/xyzscq.png"),
    },
    {
      link: require("@/assets/images/company/nfxts.png"),
    },
    {
      link: require("@/assets/images/company/qgfx.png"),
    },
    {
      link: require("@/assets/images/company/npxxx.png"),
    },
    {
      link: require("@/assets/images/company/xxpxxx.png"),
    },
    {
      link: require("@/assets/images/company/pxyw.png"),
    },
  ],
};

export const newsData = {
  // 顶部banner
  bannerLink: require("@/assets/images/news/bg_xwzx.jpg"),
  navArr: [
    "公司新闻",
    "行业动态",
    "活动资讯",
    "媒体报道",
    "媒体报道",
    "媒体报道",
  ],
  List: [
    [
      {
        link: require("@/assets/images/news/gsxw_2.png"),
        title:
          "【尊师爱教 库课荣耀】全国第38届教师节暨库课 · 天一教师年度盛典圆满举行",
        content:
          "9月8日下午，芬芳九月，礼颂师恩。尊师爱教 库课荣耀——全国第38届教师节暨库课 · 天一教师年度盛典在招银大厦22楼库课科技多功能厅圆满举行本次活动邀请到十届全国政协委员、原河南大学校长娄源  功、郑州师范学院文学院院长刘钦荣、河南枫华涉外职业培训学院院长徐颖、业务经理葛钟元、库课科技合作伙伴代表袁帆、戴暄、库课科技优秀兼职老师代表们，以及库课科技股份有限公司董事长董国良、副总裁陈小勇、副总裁汪方虎、副总裁段志伟、公司顾问王幸臣及各部门总监等领导共同庆祝全国第38届教师节暨库课 · 天一教师年度盛典大会",
        time: "2022.09.09",
        href: "https://mp.weixin.qq.com/s?__biz=MzkwMjMyNTQ1OQ==&mid=2247500717&idx=1&sn=16e6f599c8dff124a649932f5d94f53f&chksm=c0a5b611f7d23f07c1a67347f5c24bb6028d0d599d4c84d0b27a869e83bd73523dd0ddb5a80f&token=1132294765&lang=zh_CN#rd",
      },
      {
        link: require("@/assets/images/news/gsxw_1.png"),
        title: "党建引领促发展 凝心聚力谱新篇",
        content:
          "2022年9月21日上午，郑州金水区委组织部副部长张浩一行莅临库课文化科技股份有限公司，就非公党建两新引领进行了深入调研，金水区文化路办事处人大工委主任田保松、库课文化科技股份有限公司董事长董国良携同党支部书记及高管团队陪同调研",
        time: "2022.09.21",
        href: "https://mp.weixin.qq.com/s?__biz=MzkwMjMyNTQ1OQ==&mid=2247501670&idx=1&sn=c0f13f42c2c94847c9dc1f1b6505e19c&chksm=c0a5b2daf7d23bcc6906470b30d6fff543b55aa31071a3a5381469763010b92196971df12b2f&token=1132294765&lang=zh_CN#rd",
      },

      {
        link: require("@/assets/images/news/gsxw_3.png"),
        title:
          "库课铁军 荣耀出征”篮球、羽毛球团队PK赛启动仪式昨日在曼巴篮球馆成功举行",
        content:
          "2022年8月28日下午，为实现“强身健体，超越自己，团队融合，工作快乐”的内部文化，践行库课铁军标准，传递库课精神，“库课铁军 荣耀出征”篮球、羽毛球团队PK赛启动仪式在曼巴篮球中心成功举办",
        time: "2022.08.29",
        href: "https://mp.weixin.qq.com/s?__biz=MzkwMjMyNTQ1OQ==&mid=2247499196&idx=1&sn=3b6f07769585eba8d2606c5109f3e3ea&chksm=c0a58800f7d20116b956a42bb0bafe2d3f887ce1fe4d06a5eb51d4b4fddfdfed9f5fab2364ef&token=1132294765&lang=zh_CN#rd",
      },
      {
        link: require("@/assets/images/news/gsxw_4.png"),
        title: "民建河南省委会主委梁留科等领导一行莅临库课科技调研工作",
        content:
          "2022年8月10日，民建河南省委会主委梁留科等调研组一行莅临库课文化科技股份有限公司调研。民建河南省委会专职副主委杨士海，郑州市人大常委会副主任、民建郑州市委会主委孙黎，郑州市委统战部常务副部长王丽，省委统战部党派处二级调研员孙俊涛，金水区委常委、金水区委统战部部长黄国彦陪同调研。同时陪同调研的还有民建河南省委会秘书长陈颖颖，民建河南省委会办公室主任、一级调研员李军，民建省委会参政议政调研处处长杨森，民建郑州市委会专职副主委于珊，惠济区政协副主席、民建郑州市委员会副主委肖丰逸，民建郑州市委会秘书长百金丽及金水区文化路办事处相关领导",
        time: "2022.08.13",
        href: "https://mp.weixin.qq.com/s?__biz=MzkwMjMyNTQ1OQ==&mid=2247497311&idx=1&sn=33b95f07485cd800632fed929a880903&chksm=c0a583e3f7d20af59347578969e53e993bf495e3384465f6276ea6090f7d303504d6b6d0a503&token=1132294765&lang=zh_CN#rd",
      },
      {
        link: require("@/assets/images/news/gsxw_5.png"),
        title:
          "【建党伟业 信仰力量】库课科技庆祝中国共产党建党101周年大会隆重召开",
        content:
          "参加本次会议的有老党员代表河南省公安厅副厅级干部李静同志、辖区经五路社区党组织纪委书记苏艳芳同志、经八路办事处党建指导员秦志军同志、出版行业指导单位河南省新闻出版局原正厅级巡视员何新年同志、库课科技董事长兼总裁董国良、副总裁汪方虎、中共河南库课科技股份有限公司支部书记张伟及部分高管、党员代表70余人参加会议",
        time: "2022.07.01",
        href: "https://mp.weixin.qq.com/s?__biz=MzkwMjMyNTQ1OQ==&mid=2247491895&idx=1&sn=1b0c203383961d3d9a9b44e2342732c1&chksm=c0a5948bf7d21d9d5bce369cf94d995fe793265a7569c7eac2cafaa63c296a5be48f38328292&token=1132294765&lang=zh_CN#rd",
      },
      {
        link: require("@/assets/images/news/gsxw_6.png"),
        title: "创新机•开新局•谋新篇——专升本网校2022虎年启动仪式顺利举行",
        content:
          "2022年2月18日，专升本网校项目部正式召开虎年启动仪式。库课科技股份董事长兼总裁、天一镕尚品牌创始人董国良、副总裁汪方虎、副总裁段志伟、库课网校专升本项目部总监张伟、专升本教学研究院院长刘林等领导共同出席了本次启动仪式",
        time: "2022.02.22",
        href: "https://mp.weixin.qq.com/s?__biz=MzkwMjMyNTQ1OQ==&mid=2247484391&idx=1&sn=e847a409872f1b44439fa197ecc57952&chksm=c0a6765bf7d1ff4dea9e9b1a0d5d9d7ad554448b5278ebe505f14ec06f39df4a1b81bf07e834&token=1132294765&lang=zh_CN#rd",
      },
    ],
    [
      {
        link: require("@/assets/images/news/hydt_1.png"),
        title:
          "河南省教育考试院关于2022年下半年中小学教师资格考试（笔试）报名有关事项的公告",
        content:
          "根据教育部教育考试院《关于2022年中小学教师资格考试考务相关事项的通知》(教试中心函〔2021〕123号)、河南省教育厅《关于印发〈河南省中小学教师资格考试和定期注册制度改革实施方案（试行）〉的通知》（教人〔2015〕501号）等文件规定，现将2022年下半年我省中小学教师资格考试（笔试）报名有关事项公告如下",
        time: "2022.08.19",
        href: "http://www.haeea.cn/a/202208/42906_74d77320.shtml",
      },
      {
        link: require("@/assets/images/news/hydt_2.png"),
        title: "2022年特岗教师招聘考试（笔试）开考公告",
        content:
          "根据我省新冠肺炎疫情防控形势，经研究，决定于8月17日组织进行河南省2022年度特岗教师招聘考试（笔试）。现将有关事项公告如下",
        time: "2022.08.10",
        href: "http://www.haeea.cn/a/202208/42902_93130d4b.shtml",
      },
      {
        link: require("@/assets/images/news/hydt_3.png"),
        title:
          "关于本科提前批、国家专项计划本科批、对口招生本科和专升本部分院校征集志愿的通知",
        content:
          "各省辖市、济源示范区、省直管县（市）招生考试机构，各有关高校：本科提前批、国家专项计划本科批、对口招生本科和专升本院校按程序投档录取后，部分院校招生计划有余额，现面向符合条件的考生征集志愿，有关事宜通知如下",
        time: "2022.07.11",
        href: "http://www.haeea.cn/a/202207/42868_159f223c.shtml",
      },
      {
        link: require("@/assets/images/news/hydt_4.png"),
        title: "致2022年河南省特岗教师招聘考试（笔试）考生一封信",
        content:
          "各位考生：欢迎参加特岗教师招聘考试！河南省2022年特岗教师招聘考试笔试将于7月17日进行。在我省疫情常态化防控的要求下，为维护广大考生身心健康和考试公平公正，现温馨提醒如下:",
        time: "2022.07.07",
        href: "http://www.haeea.cn/a/202207/42866_fd472467.shtml",
      },
      {
        link: require("@/assets/images/news/hydt_5.png"),
        title: "专升本考试要执行最高标准、最严要求",
        content:
          "3月17日，全省专升本考试安全工作电视电话会议召开，安排部署我省2021年专升本考试安全工作，全面强化命题管理、学生管理、考试管理、监考管理等方面的责任和措施，确保专升本考试安全平稳顺利进行。副省长、省招委主任霍金花出席会议并讲话",
        time: "2022.03.19",
        href: "http://www.haeea.cn/a/202103/42471.shtml",
      },
    ],
    [
      {
        link: require("@/assets/images/news/hdzx_1.png"),
        title: "赞中国军队 · 塑库课铁军",
        content:
          "2022年7月29日，库课科技股份有限公司庆祝中国人民解放军建军95周年大会在招银大厦22层会议室隆重举行。中国人民解放军原某部政委樊玉峰大校、中国孝善天下万里行组委会主任孙继国等应邀出席会议，库课科技股份有限公司董事长董国良、副总裁陈小勇、汪方虎出席会议",
        time: "2022.08.01",
        href: "https://mp.weixin.qq.com/s?__biz=MzkwMjMyNTQ1OQ==&mid=2247495372&idx=1&sn=82f8cde6dafc9cdb9d31aba11e64d6bb&chksm=c0a59b70f7d21266ea30f8ad897d8093c102b221f6dfa0931074163468774a8ac1e908cab127&token=986006517&lang=zh_CN#rd",
      },
      {
        link: require("@/assets/images/news/hdzx_2.png"),
        title: "劳动新模范 · 库课新青年",
        content:
          "2022年4月29日上午，库课科技股份有限公司“新劳模、新青年、新未来——劳动新模范·库课新青年”双节颁奖盛典，在招银大厦22楼会议室盛大开幕！此次活动，标志库课科技精心打造的库课“劳动新模范”“库课新青年”两个新IP正式启动",
        time: "2022.04.29",
        href: "https://mp.weixin.qq.com/s/ICEu_Lo_KBVznjW4EWY0Tg",
      },
      {
        link: require("@/assets/images/news/hdzx_3.png"),
        title: "迎国庆 · 守初心",
        content:
          "为深入践行社会主义核心价值观，大力弘扬爱国主义精神和民族意识。9月30日下午，天一镕尚教育联合奥斯卡国际影城开展“迎国庆·守初心”集体观影活动，全体员工积极参与，共同庆祝祖国母亲的72周年华诞",
        time: "2021.10.01",
        href: "https://mp.weixin.qq.com/s/-niFYuMFRvK4QDFBxqirZA",
      },
    ],
    [
      {
        link: require("@/assets/images/news/mtbd_1.png"),
        title: "民建河南省委会主委梁留科等领导一行莅临库课科技调研工作",
        content:
          "2022年8月10日，民建河南省委会主委梁留科等调研组一行莅临库课文化科技股份有限公司调研。民建河南省委会专职副主委杨士海，郑州市人大常委会副主任、民建郑州市委会主委孙黎，郑州市委统战部常务副部长王丽，省委统战部党派处二级调研员孙俊涛，金水区委常委、金水区委统战部部长黄国彦陪同调研。同时陪同调研的还有民建河南省委会秘书长陈颖颖，民建河南省委会办公室主任、一级调研员李军，民建省委会参政议政调研处处长杨森，民建郑州市委会专职副主委于珊，惠济区政协副主席、民建郑州市委员会副主委肖丰逸，民建郑州市委会秘书长百金丽及金水区文化路办事处相关领导",
        time: "2022.08.15",
        href: "http://hn.ifeng.com/c/8IStLJVrTkb",
      },
      {
        link: require("@/assets/images/news/mtbd_2.png"),
        title: "库课文化董国良荣获2020中国公益慈善十大影响力企业人物",
        content:
          "第八届中国民生发展论坛暨第十四届中国国际公益慈善颁奖礼在京闭幕。“2020中国慈善十大影响力企业人物暨民生示范工程和最美全面小康建设者”奖项各有其主，河南库课文化科技股份有限公司荣获“中国慈善十大影响力企业”称号，董国良等荣获“2020中国慈善十大影响力人物”称号",
        time: "2020.12.24",
        href: "https://baijiahao.baidu.com/s?id=1686935380922798333&wfr=spider&for=pc",
      },
      {
        link: require("@/assets/images/news/mtbd_3.png"),
        title: "中原2019年度教育行业领军人物——董国良",
        content:
          "天一镕尚教育品牌创始人库课文化科技股份有限公司董事长国内资深考试类图书策划人、出版人中华家风家教城筹委会主任大型文化项目一带一路连环画《共同的故事》发起人一路走来 ，荣光背后什么事让他一直遗憾至今",
        time: "2020.01.16",
        href: "https://baijiahao.baidu.com/s?id=1655870656440790372&wfr=spider&for=pc",
      },
    ],
  ],
};

export const productsData = {
  // 顶部banner
  bannerLink: require("@/assets/images/products/bg_cybj.png"),
  // 图书出版数据
  booksData: {
    content:
      "图书出版发行是公司的主打业务之一，目前拥有全国知名院校专家兼职编辑和公司专业编辑300余人，涵盖考证类、教辅类、职业教育类三大类、七个品类，其中专升本、 教师资格证、教师招聘、高考、中职、事业单位（D类）联考考试、三支一扶考试类，有专用教材、模拟试卷、历年真题汇编、真题分类刷、必刷题、最后一卷、高分突破等系列图书。专升本覆盖全国24个省70%考生，专升本、教师类稳居同行业前列。",
    imgList: [
      require("@/assets/images/products/jf.jpg"),
      require("@/assets/images/products/zy.jpg"),
      require("@/assets/images/products/kz.jpg"),
    ],
  },
  // 专升本数据
  specialtyData: {
    title: "专升本体系产业布局",
    content:
      "天一镕尚拥有河南省唯一一家专注教学，课程优化的专业教学研究院。深入研究专升本教育、学习能力的开发和培养、前沿教育技术，不断改善学习体验。严谨科学的教研体系、人性化教材设计，帮助学生更好理解、吸收知识点，助力学生提升综合学习能力，取得更好成绩。",
    link: require("@/assets/images/products/zsb.png"),
  },
  // 职业教育
  educationData: [
    {
      link: require("@/assets/images/products/zyjy.png"),
      title: "职业教育",
      linkHover: require("@/assets/images/1.jpg"),
      content:
        "教师招聘考试培训项目，主打课程：教师资格、社招教师招聘、特岗教师招聘等三大类考试笔面试培训，自2010年立项以来，累计培训学员100000余人次，以“课程好、师资好、效果优”享誉考生界，是河南教师招聘考试培训引领品牌，系列用书成为河南省教师招聘考试学生备考的主要参考用书，被中华教育促进会评为“全国百佳教育培训机构”。",
    },
    {
      link: require("@/assets/images/products/jszg.png"),
      title: "教师资格",
      linkHover: require("@/assets/images/1.jpg"),
      content: `教师资格是国家对专门从事教育教学工作人员最基本的要求。教师资格制度是国家对教师实行的一种特定的职业许可制度。世界上许多国家对教师的资格标准都有严格的规定，不少国家建立了教师许可证制度或教师资格证书制度。
        <br/>库课教师自2010年立项以来，累计培训学员100000余人次，以“课程好、师资好、效果优”享誉考生界，是河南教师招聘考试培训引领品牌，系列用书成为河南省教师招聘考试学生备考的主要参考用书，被中华教育促进会评为“全国百佳教育培训机构”。`,
    },
    {
      link: require("@/assets/images/products/tgjs.png"),
      title: "特岗教师",
      linkHover: require("@/assets/images/1.jpg"),
      content:
        "特岗教师是中央实施的一项对西部地区农村义务教育的特殊政策，通过公开招聘高校毕业生到西部地区“两基”攻坚县以下农村学校任教，引导和鼓励高校毕业生从事农村义务教育工作，创新农村学校教师的补充机制，逐步解决农村学校师资总量不足和结构不合理等问题，提高农村教师队伍的整体素质，促进城乡教育均衡发展。",
    },
  ],
  // 在线教育
  onlineData: {
    detail: ` 库课文化科技股份有限公司，是一家集图书策划发行，数字内容出版于一体，以音频、视频、在线题库为核心的科技文化教育公司。<br/><br/> 公司立足教育领域，坚持自主策划，聚焦研发全国考试教辅教材，并与多家大型出版社如新华出版社、光明日报出版社、西北大学出版社、立信会计出版社、中国财政经济出版社等展开深度合作， 先后策划出版了大中专教材、会计资格、专升本、教师招聘、教师资格、学士学位英语等考试类教辅教材，库课图书凭借作者权威、内容精良，备受学生推崇。为顺应“互联网+”时代趋势，整合优质教育资源，2016年库课科技开始研发建设“库课网<div class="online-line"></div>以“游戏化、碎片化、娱乐化、社交化”为特色，集点播、直播、题库于一体，致力于打造“学员库、名师库、教材库、资料库、题库”五库一体兼具职业与学历教育专业特色的互联网教育平台。技术版本从1.0到2.0、3.0版本深度迭代，快速形成PC端、移动端教学平台。`,
    url: "https://kuke99.com",
    link: require("@/assets/images/products/zxjy.png"),
  },

  coachData: {
    link: require("@/assets/images/products/xlfd.png"),
    title: "学历提升",
    content:
      "成人继续教育（学历提升），按照国家规定主要有三种方式：成人高考、自学考试和远程教育三种方式。这三种方式的学历都是国家承认，学信网可查的。成人继续教育（学历提升）的人群非常广泛，年龄跨度也比较大，根据个人不同情况，可以有针对性地选择。",
    detail: "继续教育（学历提升）的方式：",
  },
  // 事业版图
  careerMap: {
    link: require("@/assets/images/products/sybt.png"),
  },
  // 产教融合
  fuseBtn: ["专业共建", "校企合作", "产业学院"],
  fuseArr: [
    {
      link: require("@/assets/images/products/gjzy.jpg"),
      title: "专业共建",
      content:
        "专业共建是指高校与企业在校内联合共同建设、开办专业学科的办学方式。在企业与高校的合作协议内，规定了双方在专业共建过程中所承担的职责。本着依托企业办专业、办好专业为企业原则，找准学校与企业利益的结合点，建立起合作多赢的动力机制。",
    },
    {
      link: require("@/assets/images/products/xqhz.jpg"),
      title: "校企合作",
      content:
        "校企合作是一种新型的办学模式，国家公办高等院校与知名企业联合创办。这也是根据发展对人才的需求而创立一种新的教学方式。有利于院校进行准确的办学定位，因地制宜地为社会适时培养所需要的紧缺人才；有利于实现校企之间优势互补、资源共享、互惠互利和共同发展。同时，对于高校与时俱进的教学理念、优化区域学科专业、优化人才培养类型、人才层次结构意义重大。",
    },
    {
      link: require("@/assets/images/products/cyxy.jpg"),
      title: "产业学院",
      content:
        "基于“直播/短视频/新媒体”为核心的网红经济产业，与高校合作，通过专业共建、课程共建、实训室共建的模式，共建产业学院，库课科技与高校共同孵化新互联网时代人才，创造产业价值，解决学生就业。",
    },
  ],
  // 校区展示
  school: {
    provinces: [
      {
        img: require("@/assets/images/products/zz.jpg"),
        title: "郑州校区",
      },
      {
        img: require("@/assets/images/products/ly.jpg"),
        title: "洛阳校区",
      },
      {
        img: require("@/assets/images/products/xc.jpg"),
        title: "许昌校区",
      },
      {
        img: require("@/assets/images/products/hb.jpg"),
        title: "鹤壁校区",
      },
      {
        img: require("@/assets/images/products/ay.jpg"),
        title: "安阳校区",
      },
      {
        img: require("@/assets/images/products/gz.jpg"),
        title: "广州校区",
      },
      {
        img: require("@/assets/images/products/sjz.jpg"),
        title: "石家庄校区",
      },
      {
        img: require("@/assets/images/products/cd.jpg"),
        title: "成都校区",
      },
      {
        img: require("@/assets/images/products/jn.jpg"),
        title: "济南校区",
      },
      {
        img: require("@/assets/images/products/km.jpg"),
        title: "昆明校区",
      },
    ],
  },
};
// 核心优势
export const advantageData = {
  // 顶部banner
  bannerLink: require("@/assets/images/advantage/advantage-banner.jpg"),
  intellectualProperty: {
    title: "知识产权体系",
    subtitle:
      "库课科技现有内容研发团队近1000人，技术研发人才近200人；拥有各类知识产权1046余件，知识产权体系完善；获评郑州市“专精特新”、“科技小巨人企业”、郑州市级科技型企业、国家级科技型企业等荣誉。计算机软件著作权305件、专利112件、商标109件、视频著作权219件、图书著作权299件、美术著作权2项。",
    list: [
      require("@/assets/images/advantage/png_jsgzl_1@2x.png"),
      require("@/assets/images/advantage/png_jsgzl_2@2x.png"),
      require("@/assets/images/advantage/png_jsgzl_3@2x.png"),
      require("@/assets/images/advantage/png_jsgzl_4@2x.png"),
      require("@/assets/images/advantage/png_wgzl_1@2x.png"),
      require("@/assets/images/advantage/png_wgzl_2@2x.png"),
      require("@/assets/images/advantage/png_wgzl_3@2x.png"),
      require("@/assets/images/advantage/png_wgzl_4@2x.png"),
      require("@/assets/images/advantage/png_tszp_1@2x.png"),
      require("@/assets/images/advantage/png_tszp_2@2x.png"),
      require("@/assets/images/advantage/png_tszp_3@2x.png"),
      require("@/assets/images/advantage/png_tszp_4@2x.png"),
    ],
  },
};

export const cooperation = {
  list: [
    require("@/assets/images/cooperation/top-bg.png"),
    require("@/assets/images/cooperation/cyhz.png"),
    // require("@/assets/images/cooperation/hzlc.png"),
    require("@/assets/images/cooperation/ppsl.png"),
    // require("@/assets/images/cooperation/ywsl.png"),
  ],
};
export const joinsData = {
  // 顶部banner
  bannerLink: require("@/assets/images/joins/joinkuke.png"),
  talentConcept: {
    title: "人才理念",
    subtitle: "用人标准",
    imgSrc: require("@/assets/images/joins/talent-concept.png"),
  },
  talentPortrait: {
    subtitle: "人才画像",
    portraits: [
      {
        img: require("@/assets/images/joins/professional.png"),
        title: "【专业水平】",
        subtitle: "个人能力、团队能力、企业能力",
      },
      {
        img: require("@/assets/images/joins/spirit.png"),
        title: "【匠人精神】",
        subtitle: "专注态度、专业能力、专业精神",
      },
      {
        img: require("@/assets/images/joins/struggle.png"),
        title: "【奋斗为本】",
        subtitle: "个人奋斗、团队奋斗、企业奋斗",
      },
      {
        img: require("@/assets/images/joins/value.png"),
        title: "【价值为纲】",
        subtitle: "个人价值、企业价值、社会价值",
      },
    ],
  },
  talentDevelopment: {
    subtitle: "人才发展观",
    developments: [
      {
        img: require("@/assets/images/joins/respect.png"),
        title: "尊重人",
        subtitle: "个人价值、企业价值、社会价值",
      },
      {
        img: require("@/assets/images/joins/culture.png"),
        title: "培养人",
        subtitle: "个人价值、企业价值、社会价值",
      },
      {
        img: require("@/assets/images/joins/achievement.png"),
        title: "成就人",
        subtitle: "个人价值、企业价值、社会价值",
      },
    ],
  },
  kkRecruitment: {
    title: "库课招聘",
    cards: [
      {
        img: require("@/assets/images/joins/pic_shzp_pc.jpg"),
        title: "社会招聘",
        des: "伯闻天下汇贤士，获才就职展前途！库课人生，cool未来！",
      },
      {
        img: require("@/assets/images/joins/pic_xyzp_pc.jpg"),
        title: "校园招聘",
        des: "精彩人生路，库课第一步！去相信去证明，梦想一触即发，青春无所畏惧！",
      },
    ],
    recruitments: {
      title: "热招岗位",
      des: "快来加入我们吧~",
      cloumns: [
        {
          prop: "address",
          label: "工作地点",
        },
        {
          prop: "post",
          label: "岗位名称",
          with: "200px",
        },
        {
          prop: "department",
          label: "所属部门",
        },
        {
          prop: "category",
          label: "岗位类别",
        },
        {
          prop: "education",
          label: "学历要求",
        },
        {
          prop: "salary",
          label: "岗位薪资",
        },
      ],
      url: "https://www.zhipin.com/gongsir/e4c4483c61d538711XN83NS_EQ~~.html?page=8&ka=page-next",
    },
  },
  contactUs: {
    title: "联系我们",
    logo: require("@/assets/images/joins/service1.png"),
    companyInfo: [
      {
        iconUrl: require("@/assets/images/joins/address.png"),
        infos: [
          {
            label: "总部办公地址：",
            value: "郑州市金水区文化路与黄河路交叉口向南300米路西库课科技大厦",
          },
          {
            label: "库课网校地址：",
            value: "郑州市金水区文化路与黄河路交叉口向南300米路西库课科技大厦",
          },
          {
            label: "库课职业教育地址：",
            value: "郑州市金水区文化路113号劳动大厦2-8层 ",
          },
          {
            label: "库课学历教育地址：",
            value: "郑州市惠济区英才街郑州工程技术学院旅游实训楼4-9层 ",
          },
        ],
      },
      {
        iconUrl: require("@/assets/images/joins/phone.png"),
        infos: [
          {
            label: "全国热线：",
            value: "400-6529-888",
          },
        ],
      },
    ],
  },
};

//底部数据
export const footerData = {
  lData: [
    {
      title: "集团介绍",
      cList: [
        { title: "集团介绍", link: "/company?#top" },
        { title: "品牌起源", link: "/company?#origin" },
        { title: "企业文化", link: "/company?#culture" },
        { title: "集团战略", link: "/company?#strategy" },
        { title: "数字库课", link: "/company?#digit" },
        { title: "企业荣誉", link: "/company?#honor" },
        { title: "品牌历程", link: "/company?#course" },
        { title: "社会责任", link: "/company?#responsibility" },
      ],
    },
    {
      title: "新闻中心",
      cList: [
        { title: "公司新闻", link: "/news?type=0" },
        { title: "行业动态", link: "/news?type=1" },
        { title: "活动资讯", link: "/news?type=2" },
        { title: "媒体报道", link: "/news?type=3" },
      ],
    },
    {
      title: "产业布局",
      cList: [
        { title: "战略事业版图", link: "/products?#domain" },
        { title: "核心业务", link: "/products?#business" },
        { title: "产教融合", link: "/products?#expand" },
        { title: "校区展示", link: "/products?#school" },
      ],
    },
    {
      title: "核心优势",
      cList: [
        { title: "一体两翼三轮驱动", link: "/advantage?#drive" },
        { title: "高通过库课引擎", link: "/advantage?#pass" },
        { title: "库课云AI+教育", link: "/advantage?#ai" },
        { title: "知识产权体系", link: "/advantage?#knowledge" },
      ],
    },
    {
      title: "全国网络",
      cList: [
        { title: "战略版图", link: "/network?#origin" },
        { title: "专升本培训全国分校", link: "/network?#zsb" },
        // { title: '公职培训全国分校', link: '/network?#gz' },
        { title: "新媒体矩阵", link: "/network?#media" },
      ],
    },
    {
      title: "商务合作",
      cList: [{ title: "诚邀合作", link: "/cooperation?#cooperate" }],
    },
    {
      title: "加入库课",
      cList: [{ title: "库课招聘", link: "/joins?#concept" }],
    },
  ],
  rData: {
    title: "关注我们",
    cList: [
      {
        title: "库课官方公众号",
        icon: require("@/assets/images/footer/wach.webp"),
        qr: require("@/assets/images/footer/gzh.png"),
      },
      {
        title: "库课官方抖音号",
        icon: require("@/assets/images/footer/douyin.webp"),
        qr: require("@/assets/images/footer/dy.png"),
      },
      {
        title: "天一专升本官方抖音号",
        icon: require("@/assets/images/footer/douyin.webp"),
        qr: require("@/assets/images/footer/tyzsbgfdyh.png"),
      },
      {
        title: "库课官方小红书号",
        icon: require("@/assets/images/footer/kkxhs.png"),
        qr: require("@/assets/images/footer/kkxhs1.png"),
      },
      {
        title: "库课官方视频号",
        icon: require("@/assets/images/footer/shipinhao.webp"),
        qr: require("@/assets/images/footer/sph.png"),
      },
      {
        title: "库课官方微博号",
        icon: require("@/assets/images/footer/weibo.webp"),
        qr: require("@/assets/images/footer/gb.png"),
      },
    ],
  },
};
//顶部数据
export const headerData = {
  hList: [
    { id: 1, list: [], flag: false },
    {
      id: 2,
      list: [
        {
          cTitle: "集团介绍",
          link: "/company?#top",
          // cList: ["公司简介", "品牌矩阵"],
        },
        {
          cTitle: "品牌起源",
          link: "/company?#origin",
          // cList: ["使命", "愿景", "价值观"],
        },
        { cTitle: "企业文化", link: "/company?#culture", cList: [] },
        {
          cTitle: "集团战略",
          link: "/company?#strategy",
          // cList: ["管理团队", "股权结构", "组织架构"],
        },
        { cTitle: "数字库课", link: "/company?#digit", cList: [] },
        { cTitle: "企业荣耀", link: "/company?#honor", cList: [] },
        { cTitle: "品牌历程", link: "/company?#course", cList: [] },
        {
          cTitle: "社会责任",
          link: "/company?#responsibility",
          // cList: ["团队风采", "个人风采"],
        },
      ],
      flag: true,
    },
    {
      id: 3,
      list: [
        {
          cTitle: "公司新闻",
          link: "/news?type=0",
          cList: [],
        },
        {
          cTitle: "行业动态",
          link: "/news?type=1",
          cList: [],
        },
        {
          cTitle: "活动资讯",
          link: "/news?type=2",
          cList: [],
        },
        {
          cTitle: "媒体报道",
          link: "/news?type=3",
          cList: [],
        },
      ],
      flag: true,
    },
    {
      id: 4,
      list: [
        {
          cTitle: "战略事业版图",
          link: "/products?#domain",
        },
        {
          cTitle: "核心业务",
          link: "/products?#business",
        },
        {
          cTitle: "产教融合",
          link: "/products?#expand",
        },
        {
          cTitle: "校区展示",
          link: "/products?#school",
        },
      ],
      flag: true,
    },
    {
      id: 5,
      list: [
        {
          cTitle: "一体两翼三轮驱动",
          link: "/advantage?#drive",
        },
        {
          cTitle: "高通过库课引擎",
          link: "/advantage?#pass",
        },
        {
          cTitle: "库课云Al+教育",
          link: "/advantage?#ai",
        },
        {
          cTitle: "知识产权体系",
          link: "/advantage?#knowledge",
        },
      ],
      flag: true,
    },
    {
      id: 6,
      list: [
        { cTitle: "战略版图", link: "/network?#origin" },
        { cTitle: "专升本培训全国分校", link: "/network?#zsb" },
        // { cTitle: '公职培训全国分校', link: '/network?#gz' },
        { cTitle: "新媒体矩阵", link: "/network?#media" },
      ],
      flag: false,
    },
    {
      id: 7,
      list: [{ cTitle: "诚邀合作", link: "/cooperation?#cooperate" }],
      flag: false,
    },
    {
      id: 8,
      list: [
        {
          cTitle: "库课招聘",
          link: "/joins?#concept",
          // cList: ["用人标准", "人才画像", "人才发展观"],
        },
      ],
    },
  ],
  oList: [
    { id: 1, title: "首页", link: "/index" },
    { id: 2, title: "集团介绍", link: "/company" },
    { id: 3, title: "新闻中心", link: "/news" },
    { id: 4, title: "产业布局", link: "/products" },
    { id: 5, title: "核心优势", link: "/advantage" },
    { id: 6, title: "全国网络", link: "/network" },
    { id: 7, title: "商务合作", link: "/cooperation" },
    { id: 8, title: "加入库课", link: "/joins" },
  ],
};

export const networkData = {
  topImg: require("@/assets/images/network/network-bg.jpg"),
  currentMap: require("@/assets/images/network/zlbt_qg.png"), // 全国总部主图
  thumbnailMap: require("@/assets/images/network/hn_thumb.png"), // 河南布局缩略图
  thumbnailMapHover: require("@/assets/images/network/hn_thumb_hover.png"), // 河南布局缩略图
  isHover: false,
  isThumbActive: false,
  isNationalMap: true,
  bList: [
    {
      img: require("@/assets/images/network/gfgzh.png"),
      title: "库课官方公众号",
    },
    {
      img: require("@/assets/images/network/kkgfdyh.png"),
      title: "库课官方抖音号",
    },
    {
      img: require("@/assets/images/network/tyzsbgfdyh.png"),
      title: "天一专升本官方抖音号",
    },
    {
      img: require("@/assets/images/network/kkgfxhsh.png"),
      title: "库课官方小红书号",
    },
    {
      img: require("@/assets/images/network/gfsph.png"),
      title: "库课官方视频号",
    },
    {
      img: require("@/assets/images/network/kkgfwbh.png"),
      title: "库课官方微博",
    },
  ],
  iListTwo: [
    {
      id: 1,
      province: "河南",
    },
  ],
  cListTwo: [
    {
      id: 1,
      children: [
        {
          title: "郑州校区",
          address: "郑州市金水区文化路与任寨北街交叉口天一镕尚教育",
          contacts: "张宝文",
          hotLine: "13781575805",
        },
        {
          title: "新密校区",
          address: "新密市行政路49号（市政府向南50米路东天一镕尚）",
          contacts: "张诗访",
          hotLine: "19937164958",
        },
        {
          title: "荥阳校区",
          address: "荥阳市郑上路与织机路交叉口路北300米路东天一教育",
          contacts: "马留森",
          hotLine: "15713697682",
        },
        {
          title: "新郑校区",
          address: "郑州市新郑市人民路御景商业街内天一招教（西亚斯东门）",
          contacts: "闫怡丹",
          hotLine: "18236926269",
        },
        {
          title: "濮阳校区",
          address: "濮阳市华龙区昆吾路卫昆街向西200米路南天一教育",
          contacts: "刘豫鑫",
          hotLine: "17657700888",
        },
        {
          title: "驻马店校区",
          address: "驻马店市驿城区文明大道春晓街交叉口向南50米路东二楼天一镕尚",
          contacts: "王蒙",
          hotLine: "18595850291",
        },
        {
          title: "兰考校区",
          address: "兰考县胜利街760号天一镕尚",
          contacts: "王波涛",
          hotLine: "17303851968",
        },
        {
          title: "开封校区",
          address: "开封市龙亭区黄河大街与汉兴路西50米路北天一镕尚",
          contacts: "王波涛",
          hotLine: "17303851968",
        },
        {
          title: "许昌校区",
          address: "许昌市魏都区学府街与德星路交叉口南50米路西院内天一镕尚",
          contacts: "刘永波",
          hotLine: "17339009922",
        },
        {
          title: "焦作校区",
          address: "焦作市山阳区人民路山阳路北100米路东天一镕尚",
          contacts: "王存孟",
          hotLine: "18703911992",
        },
        {
          title: "封丘校区",
          address: "幸福路北段封高路口向南50米路东天一招教",
          contacts: "张培红",
          hotLine: "15936567078",
        },
        {
          title: "叶县校区",
          address: "叶县皓兴御龙城南门天一教育",
          contacts: "宋超",
          hotLine: "17538292226",
        },
        {
          title: "南阳校区",
          address: "南阳市宛城区张衡路工农路万事达生活广场8号楼3楼",
          contacts: "张翰戈",
          hotLine: "13323697601",
        },
        {
          title: "太康校区",
          address: "太康县支农路西段凯旋花园对面天一教育太康分校",
          contacts: "焦龙",
          hotLine: "18595910080",
        },
        {
          title: "周口校区",
          address:
            "周口市川汇区馨丽康城小区东门往南100米天一教育（宇鑫物流华耀城店）",
          contacts: "许老师",
          hotLine: "13939422900",
        },
        {
          title: "泌阳校区",
          address: "驻马店泌阳县老妇幼保健院向西200米天一教育",
          contacts: "耿娜",
          hotLine: "17395992699",
        },
        {
          title: "尉氏校区",
          address: "河南省尉氏建设路南段天一招教学历中心",
          contacts: "王薇",
          hotLine: "13460626066",
        },
        {
          title: "新乡校区",
          address: "新乡市红旗区健康路与文化路交叉口东南角建行四楼天一招教",
          contacts: "葛朝政",
          hotLine: "13663038733",
        },
        {
          title: "原阳校区",
          address: "原阳东街老人民医院向东一百米路南",
          contacts: "王老师",
          hotLine: "13283728332",
        },
        {
          title: "长垣校区",
          address: "长垣中医院正对面向北100米路东天一教育",
          contacts: "方帅旗",
          hotLine: "17724887767",
        },
        {
          title: "永城校区",
          address: "永城市文化路南段九小对面7楼天一教育（文化派出所对面）",
          contacts: "魏涛",
          hotLine: "13569311440",
        },
        {
          title: "中牟校区",
          address:
            "河南省中牟县爱乡路中段中牟天一镕尚教学中心（鸭李骨科医院对面）",
          contacts: "彭丽",
          hotLine: "15290429483",
        },
        {
          title: "平顶山校区",
          address: "平顶山市建设路电子时代广场对面方正证券7楼整层",
          contacts: "李龙培",
          hotLine: "15537548688",
        },
        {
          title: "宝丰校区",
          address: "平顶山市宝丰县前进路春风路口向西200米路南",
          contacts: "户老师",
          hotLine: "18537557466",
        },
        {
          title: "郏县校区",
          address: "平顶山市郏县三立幼儿园对面君泰首府二楼",
          contacts: "户老师",
          hotLine: "18537557466",
        },
        {
          title: "鲁山校区",
          address: "鲁山县南环路与鲁班路交叉口向北50米路西",
          contacts: "户老师",
          hotLine: "18537557466",
        },
        {
          title: "漯河校区",
          address: "漯河市人民西路昌建广场写字楼6楼606室",
          contacts: "王书峰",
          hotLine: "18639500209",
        },
        {
          title: "洛阳校区",
          address: "洛阳市太康东路顺兴科技产业园9号楼",
          contacts: "赵轲",
          hotLine: "18638363832",
        },
        {
          title: "安阳校区",
          address: "安阳市文峰区财富公馆西单元11层天一教育",
          contacts: "郑奇奇",
          hotLine: "15896887577",
        },
        {
          title: "滑县校区",
          address: "河南省安阳市滑县振兴路与工贸路交叉向南100米（天一教育）",
          contacts: "郑奇奇",
          hotLine: "15896887577",
        },
        {
          title: "林州校区",
          address: "河南省林州市太行路与商业街交叉口物资局南楼三层天一教育",
          contacts: "焦凯力",
          hotLine: "15936831999",
        },
        {
          title: "内黄校区",
          address: "内黄县枣乡大道中段，麦肯健身五楼",
          contacts: "吴江涛",
          hotLine: "17655999444",
        },
        {
          title: "商丘校区",
          address:
            "河南省商丘市睢阳区归德路与南京路交叉口宇鑫国际1号楼2单元19楼（招教）",
          contacts: "王满义",
          hotLine: "13613888896",
        },
        {
          title: "夏邑校区",
          address:
            "河南省商丘市夏邑县知雨廊桥对面味府酒店南20米路东（天一教育）",
          contacts: "程亚飞",
          hotLine: "13523179280",
        },
      ],
    },
  ],
  iList: [
    {
      id: 1,
      province: "河南",
    },
    {
      id: 2,
      province: "山东",
    },
    {
      id: 3,
      province: "广东",
    },
    {
      id: 4,
      province: "内蒙古",
    },
    {
      id: 5,
      province: "四川",
    },
    {
      id: 6,
      province: "贵州",
    },
    {
      id: 7,
      province: "陕西",
    },
    {
      id: 8,
      province: "江西",
    },
    // {
    //   id: 9,
    //   province: "河北",
    // },
    {
      id: 10,
      province: "甘肃",
    },
    {
      id: 11,
      province: "安徽",
    },
    // {
    //   id: 12,
    //   province: '山西',
    // },
    // {
    //   id: 13,
    //   province: '江苏',
    // },
    {
      id: 14,
      province: "浙江",
    },
  ],
  cList: [
    {
      id: 1,
      children: [
        {
          title: "天一专升本北大学城VIP教学中心",
          address: "郑州市惠济区英才街与桂圆南街交叉口西北角天一专升本",
          contacts: "教学中心",
          hotLine: "0371-53300119",
        },
        {
          title: "天一专升本西大学城VIP教学中心",
          address: "郑州市中原区文竹西路与红松路交叉口260号",
          contacts: "教学中心",
          hotLine: "0371-53310875",
        },
        {
          title: "天一专升本龙子湖校区",
          address:
            "郑州市金水区龙子湖小夏街与薛夏北街交叉口大众农贸3楼天一专升本",
          contacts: "魏老师",
          hotLine: "15136132032",
        },
        {
          title: "天一专升本开封校区",
          address: "开封市东京大道夷山大街交叉口西北角天一专升本",
          contacts: "梁老师",
          hotLine: "17746388288",
        },
        {
          title: "天一专升本商丘校区",
          address: "商丘市梁园区团结路与平原路交叉口北100米路东天一专升本",
          contacts: "赵老师",
          hotLine: "0370-7716606",
        },
        {
          title: "天一专升本焦作校区",
          address: "焦作市山阳区大世界金街1号楼天一专升本",
          contacts: "吴老师",
          hotLine: "13069448007",
        },
        {
          title: "天一专升本许昌校区",
          address: "许昌市魏都区魏武大道南段阿帕克文体公园天一专升本",
          contacts: "文老师",
          hotLine: "17516257755",
        },
        {
          title: "天一专升本南大学城校区",
          address: "河南省郑州市二七区连云路与漓江交叉口东南角三楼天一专升本",
          contacts: "王老师",
          hotLine: "19913825605",
        },
        {
          title: "天一专升本巩义校区",
          address: "河南省巩义市新兴路与紫荆路交叉口向西100米天一专升本",
          contacts: "冯老师",
          hotLine: "13140195865",
        },
        {
          title: "天一专升本洛阳校区",
          address:
            "洛阳市洛龙区太康东路与新伊大街交叉口西160米院内天一专升本洛阳集训校区",
          contacts: "崔老师",
          hotLine: "16692356111",
        },
        {
          title: "天一专升本平顶山校区",
          address: "河南省平顶山市湛河区平顶山工业职业技术学院南门向西100米",
          contacts: "崔老师",
          hotLine: "13461204997",
        },
        {
          title: "天一专升本三门峡校区",
          address: "河南省三门峡市湖滨区和平路嘉亿广场5号楼15楼天一专升本",
          contacts: "张老师",
          hotLine: "15890261199",
        },
        {
          title: "天一专升本济源校区",
          address: "河南省济源市泰宏天安东写字楼三楼",
          contacts: "张老师",
          hotLine: "15236777510",
        },
        {
          title: "天一专升本郑西校区",
          address: "郑州市中原区西流湖街道华瑞紫韵城福园西门天一专升本",
          contacts: "吕老师",
          hotLine: "19303971211",
        },
        {
          title: "天一专升本信阳校区",
          address:
            "河南省信阳市平桥区前进街道新二十四大街信阳开元国际饭店东附5楼501",
          contacts: "程老师",
          hotLine: "15518900711",
        },
        {
          title: "天一专升本南阳校区",
          address: "河南省南阳市卧龙区龙锦嘉园（外环路西150米）",
          contacts: "张老师",
          hotLine: "13323827175",
        },
        {
          title: "天一专升本马寨校区",
          address: "郑州市二七区马寨镇工业路12号天一专升本马寨旗舰校区",
          contacts: "韩老师",
          hotLine: "17337772113",
        },
        {
          title: "天一专升本周口校区",
          address:
            "周口市川汇区周口大道与松花江路交叉口周口文理对面天明城财富广场17号楼5楼",
          contacts: "孔老师",
          hotLine: "15290076690",
        },
        {
          title: "天一专升本象湖校区",
          address: "中牟县增福街豫兴家苑三号院商业1号楼1-4层天一专升本象湖分校",
          contacts: "李老师",
          hotLine: "15136132192",
        },
        {
          title: "天一专升本新乡校区",
          address: "河南省新乡市红旗区向阳路东段建业世和府南门天一专升本",
          contacts: "张老师",
          hotLine: "17839882808",
        },
        {
          title: "天一专升本安阳校区",
          address:
            "河南省安阳市文峰区宝莲寺镇易商谷园区11号楼一楼天一专升本（集训基地）",
          contacts: "孙老师",
          hotLine: "13303857167",
        },
        {
          title: "天一专升本北大学城校区",
          address: "郑州市惠济区英才街与桂圆南街交叉口旅游实训楼2楼天一专升本",
          contacts: "李老师",
          hotLine: "19339906812",
        },
        {
          title: "天一专升本鹤壁校区",
          address:
            "河南省鹤壁市淇滨区天山办事处朝歌路与天山路交叉口汇金商业广场D栋3楼天一专升本",
          contacts: "李老师",
          hotLine: "19339906812",
        },
        {
          title: "天一专升本漯河校区",
          address: "河南省漯河市长江路望泽超市临街2楼天一专升本",
          contacts: "赵老师",
          hotLine: "16716601177",
        },
        {
          title: "天一专升本中牟校区",
          address:
            "郑州市中牟县商都大道与中兴路交叉口向西50米路南一层（天一专升本中牟旗舰校区）",
          contacts: "彭老师",
          hotLine: "17737770220",
        },
        {
          title: "天一专升本濮阳校区",
          address: "河南省濮阳市华龙区开州南路23号天一教育",
          contacts: "李老师",
          hotLine: "17597963310",
        },
        {
          title: "天一专升本中心校区",
          address: "郑州市金水区花园路晶竹商务二楼天一专升本",
          contacts: "刘老师",
          hotLine: "19937686008",
        },
        {
          title: "天一专升本龙湖校区",
          address:
            "郑州市新郑市龙湖镇文昌路中段前胡东社区天一专升本（龙湖旗舰校区）",
          contacts: "朱老师",
          hotLine: "19337888279",
        },
        {
          title: "天一专升本荥阳校区",
          address:
            "郑州市荥阳市豫龙镇郑州职业技术学院向西200米天一专升本（荥阳旗舰校区）",
          contacts: "刘老师",
          hotLine: "15617881547",
        },
        {
          title: "天一专升本新郑校区",
          address: "新郑市人民路西亚斯御景商业街4-118",
          contacts: "李老师",
          hotLine: "13298120025",
        },
        {
          title: "天一专升本驻马店校区",
          address: "驻马店驿城区金河街置地大道甲壳虫公寓5号楼三楼",
          contacts: "孙老师",
          hotLine: "15539683088",
        },
      ],
    },
    {
      id: 2,
      children: [
        {
          title: "山东总校",
          address:
            "山东省济南市章丘区双山街道双创基地10号楼库课专升本山东运营中心",
          contacts: "王中辉",
          hotLine: "18264119217",
        },
        {
          title: "山东长清咨询点",
          address: "济南市长清区海棠路8366号联合科技孵化中心122",
          contacts: "郭荣波",
          hotLine: "18264118379",
        },
        {
          title: "山东青岛加盟校区",
          address: "青岛市黄岛区滨海大道星光岛星光汇科教园",
          contacts: "李鹏飞",
          hotLine: "15288985428",
        },
      ],
    },
    {
      id: 3,
      children: [
        {
          title: "广东集训基地",
          address:
            "广东省广州市天河区元岗街道天源路773号库课专升本考试集训基地",
          contacts: "彭老师",
          hotLine: "18620220733",
        },
        {
          title: "广州-花都校区",
          address:
            "广东省广州市花都区赤坭镇岭西大道广州民航职业技术学院 对面库课专升本",
          contacts: "张老师",
          hotLine: "13060606208",
        },
        {
          title: "佛山-高明校区",
          address: "广东省佛山市高明区荷城街道江湾商业广场库课专升本",
          contacts: "许老师",
          hotLine: "13246222391",
        },
        {
          title: "佛山-南海校区",
          address: "广东省佛山市南海区广东轻工职业技术学院门口",
          contacts: "于老师",
          hotLine: "15363145231",
        },
        {
          title: "珠海校区",
          address: "广东省珠海市金湾区金鑫路旭日海岸库课专升本（珠海分校）三楼",
          contacts: "周老师",
          hotLine: "15037052080",
        },
        {
          title: "湛江校区",
          address: "广东省湛江市遂溪县遂城镇朝阳路库课专升本",
          contacts: "黄老师",
          hotLine: "19126497946",
        },
        {
          title: "揭阳校区",
          address: "广东省揭阳市榕城区仙桥镇揭阳职业技术学院正对面库课专升本",
          contacts: "陈老师",
          hotLine: "18320429228",
        },
        {
          title: "罗定校区",
          address: "广东省云浮市罗定市罗定职业技术学院旧校区旁库课专升本",
          contacts: "秦老师",
          hotLine: "13555646247",
        },
        {
          title: "惠州校区",
          address: "广东省惠州市惠城区三栋镇明德路库课专升本1楼",
          contacts: "孙老师",
          hotLine: "18476668414",
        },
        {
          title: "阳江校区",
          address: "广东省阳江市阳江职业学院隔壁",
          contacts: "吴老师",
          hotLine: "18113203961",
        },
      ],
    },
    {
      id: 4,
      children: [
        {
          title: "内蒙古校区",
          address: "呼和浩特市新城区保合少镇兴古文化园5栋103号商铺",
          contacts: "王老师",
          hotLine: "15354878061",
        },
      ],
    },
    {
      id: 5,
      children: [
        {
          title: "成都总部校区",
          address: "四川省成都市成华区中凯空间（龙腾广场）11楼1106-8号",
          contacts: "成都总部",
          hotLine: "02867571801",
        },
        {
          title: "成都标榜校区",
          address: "四川省成都市龙泉驿区四川国际标榜职业学院旁",
          contacts: "苟骞骞",
          hotLine: "17723309573",
        },
        {
          title: "大邑校区",
          address: "成都市大邑县安仁镇客运中心旁",
          contacts: "毛杨",
          hotLine: "13378308606",
        },
        {
          title: "温江校区",
          address: "温江区德通桥永宁正街183号 中门",
          contacts: "李泯宏",
          hotLine: "17628114780",
        },
        {
          title: "和盛校区",
          address: "温江区和盛镇鹏飞路313号 (莲花坊小区旁)",
          contacts: "王杰",
          hotLine: "18382221096",
        },
        {
          title: "绵职校区",
          address: "绵阳市游仙区绵职院南门对面斜坡1楼",
          contacts: "曹青青",
          hotLine: "18881616235",
        },
        {
          title: "医专校区",
          address: "绵阳市涪城区教育中路上庠商业街2-1号",
          contacts: "李白",
          hotLine: "18884228721",
        },
        {
          title: "德阳校区",
          address: "四川省德阳市旌阳区工农街道金江街52号附305",
          contacts: "黄小虎",
          hotLine: "15983840305",
        },
        {
          title: "德阳校区（川护）",
          address: "德阳市旌阳区东一环路新华临时市场内",
          contacts: "黄小虎",
          hotLine: "15983840305",
        },
        {
          title: "南职校区",
          address: "四川省南充市高坪区小龙街道龙城国际 1 楼",
          contacts: "任跃",
          hotLine: "15984867714",
        },
        {
          title: "文旅校区",
          address: "四川省南充市阆中市河溪镇河东大道92号库课专升本",
          contacts: "杨伟",
          hotLine: "18280101082",
        },
        {
          title: "西充校区",
          address: "四川省南充市西充县多扶镇福镇15-1-93号",
          contacts: "但宝玲",
          hotLine: "19161271048",
        },
        {
          title: "巴中校区",
          address: "巴中市经开区宇亿叠翠商业街3楼",
          contacts: "王思雨",
          hotLine: "19983658120",
        },
        {
          title: "广安校区",
          address:
            "教学点1：广安市广安区广职院大门旁小吃街2楼。\n教学点2：广安市广安区广职院后门创业园3栋209",
          contacts: "胡聪",
          hotLine: "19980329939",
        },
        {
          title: "达州校区",
          address:
            "达州市通川区韩家坝社区凤栖酒楼3楼\n达州职业技术学院(篮球场对面库课专升本咨询点)",
          contacts: "李建伟",
          hotLine: "15315881754",
        },
        {
          title: "宜宾校区",
          address: "四川省宜宾市南溪区仙源街道石马社区五组3号",
          contacts: "江伟",
          hotLine: "19881236125",
        },
        {
          title: "雅安校区",
          address:
            "经开校区：德坤广场6栋3楼库课专升本。\n青年路校区：恒信上海城9栋2楼库课专升本",
          contacts: "郭灯",
          hotLine: "15208111506",
        },
        {
          title: "眉山药科校区",
          address: "眉山市丹棱县眉山药科职业学院正大门对面3楼",
          contacts: "付国浪",
          hotLine: "18382313218",
        },
        {
          title: "乐山校区",
          address: "乐山市市中区苏稽镇西岸广场2楼1-A号",
          contacts: "赵宇龙",
          hotLine: "15386511474",
        },
        {
          title: "都江堰校区",
          address: "都江堰市四川工商职业技术学院西门外双水花园小区旁1楼",
          contacts: "吴兴",
          hotLine: "18982126693",
        },
        {
          title: "广元校区",
          address:
            "四川省广元市利州区学府路园中园1栋3楼（广元外国语学校正对面）",
          contacts: "吴胜",
          hotLine: "19381056693",
        },
        {
          title: "泸化校区",
          address: "四川省泸州市纳溪区城投悦来城4楼4-454商铺",
          contacts: "卢浩",
          hotLine: "18328505204",
        },
        {
          title: "泸职校区",
          address: "四川省泸州市龙马潭区西南商贸城1区",
          contacts: "李涵",
          hotLine: "18884364198",
        },
        {
          title: "绵竹校区",
          address: "绵竹市天一学院南门正对面剑桥城3栋2楼",
          contacts: "吴兴",
          hotLine: "18982126693",
        },
        {
          title: "崇州校区",
          address: "四川省崇州市江源街道永和大道大石桥1巷21号",
          contacts: "毛老师",
          hotLine: "13378308606",
        },
        {
          title: "西昌校区",
          address: "凉山州西昌市数字经济产业园A3栋16楼",
          contacts: "熊斌",
          hotLine: "18892807753",
        },
        // {
        //   title: "新津校区",
        //   address: "成都市新津区花源镇正源路96号4楼",
        //   contacts: "曾老师",
        //   hotLine: "17780546502",
        // },
        {
          title: "川电机校区",
          address: "四川省绵阳市游仙区松垭镇德政街四区12栋3号",
          contacts: "朱慧琳",
          hotLine: "18881155521",
        },
        {
          title: "金堂校区",
          address: "金堂大学城学府大道655号10栋401号",
          contacts: "刘强",
          hotLine: "15828219149",
        },
        {
          title: "遂宁校区",
          address: "四川省遂宁市船山区香林南路置信丽府B区4-2-5",
          contacts: "周芸凌",
          hotLine: "13909061859",
        },
        {
          title: "泸州江阳校区",
          address: "四川省泸州市龙马潭区蜀宁路蓝光长岛国际社区库课专升本",
          contacts: "卢老师",
          hotLine: "18328505204",
        },
      ],
    },
    {
      id: 6,
      children: [
        {
          title: "贵州校区",
          address: "贵州贵阳清镇市职教路2号",
          contacts: "秦老师",
          hotLine: "15538316711",
        },
      ],
    },
    {
      id: 7,
      children: [
        {
          title: "库课网校咸阳体验馆",
          address: "陕西省咸阳市秦都区沣西吾悦广场秦潮里二楼1#-10227",
          contacts: "张老师",
          hotLine: "13060606208",
        },
      ],
    },
    {
      id: 8,
      children: [
        {
          title: "南昌中心校区",
          address: "江西省南昌市青山湖区江纺1953文化教育产业园",
          contacts: "张老师",
          hotLine: "18037873752",
        },
        {
          title: "抚州校区",
          address:
            "江西省抚州市临川区文昌大道2777号文昌壹号1-6号库课专升本抚州校区",
          contacts: "刘老师",
          hotLine: "15180155591",
        },
      ],
    },
    // {
    //   id: 9,
    //   children: [
    //     {
    //       title: "河北库课天一教育科技有限公司",
    //       address: "河北省石家庄市桥西区汇丰路8号西美花街大厦1708-1室",
    //       contacts: "许老师",
    //       hotLine: "15530067077",
    //     },
    //   ],
    // },
    {
      id: 10,
      children: [
        {
          title: "甘肃兰州新区校区（合作）",
          address: "兰州市兰州新区职教园区商业配套一期7号楼8楼",
          contacts: "康老师",
          hotLine: "18893115228",
        },
      ],
    },
    {
      id: 11,
      children: [
        {
          title: "合肥职教城校区（合作）",
          address: "安徽省合肥市瑶海区 合肥智慧产业园A15栋7楼",
          contacts: "金老师",
          hotLine: "15922440904",
        },
        {
          title: "合肥审计学院校区（合作）",
          address:
            "安徽省合肥市经济技术开发区 始信路731号鸣华大厦1205（滨湖学院马路对面）",
          contacts: "段老师",
          hotLine: "19355962585",
        },
        {
          title: "合肥校区集训基地（合作）",
          address:
            "安徽省合肥市新站综合开发试验区 学林路699号（与相山路交口西南角）安徽万通技师学院东门",
          contacts: "金老师",
          hotLine: "15922440904",
        },
      ],
    },
    {
      id: 12,
      children: [
        {
          title: "太原晋中校区（合作）",
          address: "山西省晋中市榆次区文华街555号米加U天地库课专升本",
          contacts: "张老师",
          hotLine: "13513624424",
        },
      ],
    },
    {
      id: 13,
      children: [
        {
          title: "江苏南京校区（合作）",
          address: "江苏省南京市江宁区江苏经贸职业技术学院校内",
          contacts: "孙老师",
          hotLine: "13023406856",
        },
      ],
    },
    {
      id: 14,
      children: [
        {
          title: "库课专升本湖州校区（合作）",
          address: "浙江省湖州市吴兴区滨湖街道鑫美路56号",
          contacts: "姚老师",
          hotLine: "15557101855",
        },
      ],
    },
  ],
};
